import type { AutomationStepType } from '@marketing-hub/shared';

export const AUTOMATION_STEP_LABELS: Record<AutomationStepType, string> = {
  lead_add_tag: 'Lead — tag toevoegen',
  lead_set_status: 'Lead — status wijzigen',
  lead_append_note: 'Lead — notitie',
  emit_webhook: 'Webhook automation.executed',
  enqueue_job: 'Background job enqueue',
  run_agent: 'AI-agent uitvoeren',
  draft_reply: 'Concept antwoord (HITL)',
  generate_analytics_report: 'Analytics rapport (GA4/GSC)',
};
